module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-376.5b1ec38.woff2";